import NumberBox from "devextreme-react/number-box";
import { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadKhoanNopStart } from "../../../state/actions/khoanNopActions";
import {
  XIcon,
  CheckIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "@primer/octicons-react";
import { Box, Checkbox, IconButton } from "@primer/react";

import { AddKhoanNopModalRespone } from "..";
import { mucPhaiThuChiTietApi } from "../../../api/mucPhaiThuChiTietApi";
import { mucThuPhiApi } from "../../../api/mucThuPhiApi";
import CmbHinhThucNopBom from "../../../components/combobox-hinh-thuc-nop-bom";
import { NamHocTruongKhoiHeFilter } from "../../../models/namHocTruongKhoiHeFilter";
import { sf_hinhthucnopbom } from "../../../models/response/category/sf_hinhthucnopbom";
import { RootState } from "../../../state/reducers";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import DataTable from "../../../components/ui/data-table";
import TextInput from "../../../components/ui/text-input";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { khoanNopGroupApi } from "../../../api/khoanNopGroupApi";
import SelectBoxMultipleKhomKhoanNop from "../../selectbox-nhomkhoannop/SelectBoxMultipleKhomKhoanNop";
import { DefaultPopup } from "../../modal";
import { formatVND } from "../../../utils/formatVND";

type AddKhoanNopFromKhoanNopProps = {
  sf_khoannop_ids_added?: number[];
  onSelected: (data: AddKhoanNopModalRespone) => void;
  onCancel: () => void;
  isSaving: boolean;
  filter: NamHocTruongKhoiHeFilter;
  nam_nhap_hoc?: string;
  ts_hocsinh_id: number;
  sf_hinhthucnopbom_ids?: string;
};
export const AddKhoanNopFromKhoanNop = (
  props: AddKhoanNopFromKhoanNopProps
) => {
  const { dm_coso_id } = useSelector((state: RootState) => state.common);
  const { sf_khoannops } = useSelector((x: RootState) => x.khoanNop);
  const { sf_nhomkhoannops } = useSelector((x: RootState) => x.nhomKhoanNop);
  const [sf_mucthuphi_selected_ids, set_sf_mucthuphi_selected_ids] = useState<
    number[]
  >([]);
  const [is_tinh_mien_giam, set_is_tinh_mien_giam] = useState<boolean>(true);
  const [isShowPlaceHolder, SetIsShowPlaceHolder] = useState<boolean>(true);
  const [sf_mucthuphi_datasource, set_sf_mucthuphi_datasource] = useState<
    any[]
  >([]);
  const [hinhThucNopBoms, setHinhThucNopBoms] = useState<sf_hinhthucnopbom[]>(
    []
  );
  const [selectedNhomKhoanNopIds, setSelectedNhomKhoanNopIds] = useState<
    number[]
  >([]);
  const [selectedNhomKhoanNopNames, setSelectedNhomKhoanNopNames] = useState<
    string[]
  >([]);
  const [khoanDaNops, setKhoanDaNops] = useState<number[]>([]);
  const [khoanNopDichVuIds, setKhoanNopDichVuIds] = useState<number[]>([]);
  const [summary, setSummary] = useState<number>();
  const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(
    new Map()
  );
  const [originalDataSource, setOriginalDataSource] = useState<any[]>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadKhoanNopStart());
  }, [dispatch, sf_khoannops.length === 0]);

  const handleReloadKhoanNopDichVu = useCallback(async () => {
    const request = {
      dm_coso_id: dm_coso_id,
      ts_hocsinh_id: props.ts_hocsinh_id,
      nam_hoc: props.filter.nam_hoc,
    };
    const res = await khoanNopGroupApi.select_dichvu_by_hs(request);
    if (res.is_success) {
      const khoanNopIds = res.data
        .filter(
          (x: any) =>
            x.sf_saleset_register_dichvu_status_id === 1 ||
            x.sf_saleset_register_dichvu_status_id === 2
        )
        .map((x: any) => x.sf_khoannop_group_id);
      setKhoanNopDichVuIds(khoanNopIds);
    }
  }, [dm_coso_id, props.ts_hocsinh_id, props.filter.nam_hoc]);

  useEffect(() => {
    handleReloadKhoanNopDichVu();
  }, [handleReloadKhoanNopDichVu]);

  // Memoize originalDataSource IDs để detect thay đổi về cấu trúc
  const originalDataSourceIds = useMemo(() => {
    return originalDataSource
      .map((x) => x.id)
      .sort()
      .join(",");
  }, [originalDataSource]);

  // Memoize khoanDaNops và khoanNopDichVuIds để tránh re-compute không cần thiết
  const khoanDaNopsStr = useMemo(
    () => (khoanDaNops || []).slice().sort().join(",") || "",
    [khoanDaNops]
  );
  const khoanNopDichVuIdsStr = useMemo(
    () => khoanNopDichVuIds.slice().sort().join(",") || "",
    [khoanNopDichVuIds]
  );
  const hinhThucNopBomsIdsStr = useMemo(
    () =>
      hinhThucNopBoms
        .map((obj: { id: number }) => obj.id)
        .sort()
        .join(",") || "",
    [hinhThucNopBoms]
  );

  // Filter data source khi khoanDaNops, khoanNopDichVuIds hoặc hinhThucNopBoms thay đổi
  // Chỉ filter lại khi danh sách IDs thay đổi, không phải khi giá trị trong items thay đổi
  const filteredDataSource = useMemo(() => {
    if (originalDataSource.length === 0) return [];

    let filterData = originalDataSource.filter(
      (x: any) => !khoanDaNops || !khoanDaNops.includes(x.sf_khoannop_id)
    );

    // Filter theo hinhThucNopBoms nếu có
    if (
      hinhThucNopBoms.length > 0 &&
      hinhThucNopBoms[0] !== undefined &&
      hinhThucNopBoms[0] != null
    ) {
      const sf_htnb_ids = hinhThucNopBoms
        .filter((obj) => obj && obj.id)
        .map((obj: { id: number }) => obj.id);
      filterData = filterData.filter((x: any) =>
        x.sf_hinhthucnopbom_ids
          ?.split(",")
          .map((id: string) => parseInt(id, 10))
          .some((id: number) => sf_htnb_ids.includes(id))
      );
    }

    // Filter theo nhóm khoản nộp
    if (selectedNhomKhoanNopIds.length > 0) {
      const selectedNames =
        selectedNhomKhoanNopNames && selectedNhomKhoanNopNames.length > 0
          ? selectedNhomKhoanNopNames
          : [];
      filterData = filterData.filter((x: any) =>
        selectedNames.includes(x.nhom_khoan_nop)
      );
    }

    if (khoanNopDichVuIds.length > 0) {
      filterData = filterData.filter(
        (x: any) =>
          x.sf_loaikhoannop_id === 4 ||
          !x.is_dichvu ||
          khoanNopDichVuIds.includes(x.sf_khoannop_group_id)
      );
    } else {
      filterData = filterData.filter((x: any) => !x.is_dichvu);
    }
    return filterData;
  }, [
    khoanDaNopsStr,
    khoanNopDichVuIdsStr,
    hinhThucNopBomsIdsStr,
    selectedNhomKhoanNopIds,
    selectedNhomKhoanNopNames,
    originalDataSourceIds,
    originalDataSource,
    khoanDaNops,
    khoanNopDichVuIds,
    hinhThucNopBoms,
  ]);

  // Memoize filteredDataSource IDs để detect thay đổi về cấu trúc
  const filteredDataSourceIds = useMemo(() => {
    return filteredDataSource
      .map((x) => x.id)
      .sort()
      .join(",");
  }, [filteredDataSource]);

  // Chỉ update sf_mucthuphi_datasource khi filteredDataSource thay đổi về mặt cấu trúc (thêm/xóa items)
  useEffect(() => {
    set_sf_mucthuphi_datasource((prev) => {
      const prevIds = prev
        .map((x) => x.id)
        .sort()
        .join(",");

      if (
        prevIds === filteredDataSourceIds &&
        prev.length === filteredDataSource.length
      ) {
        return prev; // Không thay đổi, giữ nguyên reference
      }

      // Merge với dữ liệu hiện tại để giữ lại các giá trị đã chỉnh sửa
      const merged = filteredDataSource.map((newItem) => {
        const existing = prev.find((x) => x.id === newItem.id);
        if (existing) {
          // Giữ lại các giá trị đã chỉnh sửa
          return {
            ...newItem,
            so_tien_phai_nop: existing.so_tien_phai_nop,
            ghi_chu: existing.ghi_chu,
          };
        }
        return newItem;
      });
      return merged;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredDataSourceIds]);

  // Memoize filter để tránh re-render không cần thiết
  const filterKey = useMemo(() => {
    return `${props.filter.dm_he_id}_${props.filter.dm_khoi_id}_${props.filter.dm_truong_id}_${props.filter.nam_hoc}_${props.nam_nhap_hoc}_${props.ts_hocsinh_id}`;
  }, [
    props.filter.dm_he_id,
    props.filter.dm_khoi_id,
    props.filter.dm_truong_id,
    props.filter.nam_hoc,
    props.nam_nhap_hoc,
    props.ts_hocsinh_id,
  ]);

  const handleReloadMucPhaiThuChiTiet = useCallback(async () => {
    const request = {
      nam_hoc: props.filter.nam_hoc,
      ts_hocsinh_id: props.ts_hocsinh_id,
    };
    const res = await mucPhaiThuChiTietApi.select_all_khoannop(request);
    if (res.is_success) {
      const khoanDaNopIds = res.data.map((x: any) => x.sf_khoannop_id);
      setKhoanDaNops(khoanDaNopIds);
    }
  }, [props.filter.nam_hoc, props.ts_hocsinh_id]);

  const handleReloadKhoanNop = useCallback(async () => {
    let isLoading = true;
    const intever_obj = setInterval(() => {
      if (!isLoading) {
        clearInterval(intever_obj);
        SetIsShowPlaceHolder(false);
      }
    }, 200);
    const datasend = {
      dm_he_id: props.filter.dm_he_id,
      dm_khoi_id: props.filter.dm_khoi_id,
      dm_truong_id: props.filter.dm_truong_id,
      nam_hoc: props.filter.nam_hoc,
      nam_nhap_hoc:
        props.nam_nhap_hoc === undefined
          ? props.filter.nam_hoc
          : props.nam_nhap_hoc,
    };
    const res = await mucThuPhiApi.select_by_nam_nhap_hoc(datasend);
    if (res.is_success) {
      let sf_mucthuphi_datasource = res.data
        .filter((x: any) => {
          // Nếu nam_nhap_hoc được truyền vào, chỉ lấy những khoản nộp có nam_nhap_hoc khớp
          // Nếu không có nam_nhap_hoc, lấy tất cả dữ liệu từ API
          if (
            props.nam_nhap_hoc !== undefined &&
            props.nam_nhap_hoc !== null &&
            props.nam_nhap_hoc !== ""
          ) {
            return x.nam_nhap_hoc === props.nam_nhap_hoc;
          }
          return true;
        })
        .map((x: any) => {
          return {
            ...x,
            so_tien_phai_nop: x.so_tien,
            ghi_chu: "",
          };
        });
      if (props.sf_khoannop_ids_added) {
        sf_mucthuphi_datasource = sf_mucthuphi_datasource.filter(
          (x: any) =>
            props.sf_khoannop_ids_added === undefined ||
            !props.sf_khoannop_ids_added.includes(x.sf_khoannop_id)
        );
      }
      // Không filter theo hinhThucNopBoms ở đây nữa, để filteredDataSource xử lý
      // Lưu vào originalDataSource để filter sau
      // Không set sf_mucthuphi_datasource trực tiếp ở đây, để filteredDataSource và useEffect xử lý
      setOriginalDataSource(sf_mucthuphi_datasource);
    }
    handleReloadMucPhaiThuChiTiet();
    isLoading = false;
  }, [
    props.filter.dm_he_id,
    props.filter.dm_khoi_id,
    props.filter.dm_truong_id,
    props.filter.nam_hoc,
    props.nam_nhap_hoc,
    props.sf_khoannop_ids_added,
    handleReloadMucPhaiThuChiTiet,
  ]);

  useEffect(() => {
    handleReloadKhoanNop();
  }, [filterKey, handleReloadKhoanNop]);

  const raw_data_source = useMemo(() => {
    return sf_mucthuphi_datasource.map((item) => ({
      ...item,
      so_tien_phai_nop: item.so_tien_phai_nop || item.so_tien || 0,
    }));
  }, [sf_mucthuphi_datasource]);

  const data_source = useMemo(() => {
    // Group data by nhom_khoan_nop
    const groupedData: Record<string, any[]> = {};
    raw_data_source.forEach((item: any) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }
      groupedData[groupKey].push(item);
    });

    // Flatten data with group headers
    const result: any[] = [];
    Object.keys(groupedData).forEach((groupKey) => {
      // Add group header row
      result.push({
        id: `group_${groupKey}`,
        isGroupHeader: true,
        nhom_khoan_nop: groupKey,
        ma_khoan_nop: "",
        ten_khoan_nop: `Nhóm: ${groupKey}`,
        groupItems: groupedData[groupKey],
        isExpanded: expandedGroups.has(groupKey),
      });

      // Chỉ add group items nếu group được expand
      if (expandedGroups.has(groupKey)) {
        groupedData[groupKey].forEach((item) => {
          result.push({
            ...item,
            isGroupHeader: false,
            parentGroup: groupKey,
          });
        });
      }
    });

    return result;
  }, [raw_data_source, expandedGroups]);

  // Memoize groups để tránh re-compute không cần thiết
  const uniqueGroupsStr = useMemo(() => {
    if (raw_data_source.length === 0) return "";
    const uniqueGroups = new Set<string>();
    raw_data_source.forEach((item) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      uniqueGroups.add(groupKey);
    });
    return Array.from(uniqueGroups).sort().join(",");
  }, [raw_data_source]);

  // Tự động expand tất cả groups khi có dữ liệu mới (chỉ khi groups thay đổi)
  useEffect(() => {
    if (!uniqueGroupsStr) return;

    setExpandedGroups((prev) => {
      const currentGroups = Array.from(prev.keys()).sort().join(",");
      if (currentGroups !== uniqueGroupsStr) {
        const newExpandedGroups = new Map<string, string>();
        uniqueGroupsStr.split(",").forEach((groupKey) => {
          newExpandedGroups.set(groupKey, groupKey);
        });
        return newExpandedGroups;
      }
      return prev;
    });
  }, [uniqueGroupsStr]);

  useEffect(() => {
    const totalAmount = raw_data_source
      .filter((x) => sf_mucthuphi_selected_ids.includes(x.id))
      .reduce((count, item) => {
        return (
          count +
          (item.so_tien_phai_nop === undefined || item.so_tien_phai_nop === 0
            ? item.so_tien
            : item.so_tien_phai_nop)
        );
      }, 0);
    setSummary(totalAmount);
  }, [sf_mucthuphi_selected_ids, raw_data_source]);

  const toggleGroup = useCallback((groupKey: string) => {
    setExpandedGroups((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(groupKey)) {
        newMap.delete(groupKey);
      } else {
        newMap.set(groupKey, groupKey);
      }
      return newMap;
    });
  }, []);

  const handleGroupSelection = useCallback(
    (groupKey: string, isSelected: boolean) => {
      const groupItems = raw_data_source.filter(
        (item) => (item.nhom_khoan_nop || "Khác") === groupKey
      );
      const groupItemIds = groupItems.map((item) => item.id);

      if (isSelected) {
        const newSelection = [...sf_mucthuphi_selected_ids];
        groupItemIds.forEach((id) => {
          if (!newSelection.includes(id)) {
            newSelection.push(id);
          }
        });
        set_sf_mucthuphi_selected_ids(newSelection);
      } else {
        const newSelection = sf_mucthuphi_selected_ids.filter(
          (id) => !groupItemIds.includes(id)
        );
        set_sf_mucthuphi_selected_ids(newSelection);
      }
    },
    [raw_data_source, sf_mucthuphi_selected_ids]
  );

  const handleItemSelection = useCallback(
    (itemId: number, isSelected: boolean) => {
      if (isSelected) {
        if (!sf_mucthuphi_selected_ids.includes(itemId)) {
          set_sf_mucthuphi_selected_ids([...sf_mucthuphi_selected_ids, itemId]);
        }
      } else {
        set_sf_mucthuphi_selected_ids(
          sf_mucthuphi_selected_ids.filter((id) => id !== itemId)
        );
      }
    },
    [sf_mucthuphi_selected_ids]
  );

  const handleSoTienChange = useCallback((rowId: number, value: number) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.so_tien_phai_nop === value) {
        return prev; // Không thay đổi, trả về cùng reference
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, so_tien_phai_nop: value };
        }
        return x;
      });
    });
  }, []);

  const handleGhiChuChange = useCallback((rowId: number, value: string) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.ghi_chu === value) {
        return prev; // Không thay đổi, trả về cùng reference
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, ghi_chu: value };
        }
        return x;
      });
    });
  }, []);

  const handelSubmit = () => {
    const data = {
      sf_bom_id: 0,
      is_calculate_miengiam: is_tinh_mien_giam,
      sf_bom_chitiets: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_mucthuphis: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_hinhthucnopbom_id:
        hinhThucNopBoms.length > 0 &&
        hinhThucNopBoms[0] !== undefined &&
        hinhThucNopBoms[0] !== null
          ? hinhThucNopBoms[0].id
          : 0,
    };
    props.onSelected(data);
    handleReloadMucPhaiThuChiTiet();
  };

  const columns = useMemo(() => {
    const result: any[] = [
      {
        caption: "Tên khoản nộp",
        id: "ten_khoan_nop",
        dataField: "ten_khoan_nop",
        width: "250px",
        align: "left",
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => {
          const isExpanded = expandedGroups.has(data.nhom_khoan_nop || "Khác");
          const level = data.isGroupHeader ? 0 : 1;
          const isGroup = data.isGroupHeader;

          if (isGroup) {
            const groupKey = data.nhom_khoan_nop || "Khác";
            const groupItems = raw_data_source.filter(
              (item) => (item.nhom_khoan_nop || "Khác") === groupKey
            );
            const groupItemIds = groupItems.map((item) => item.id);
            const isAllSelected =
              groupItemIds.length > 0 &&
              groupItemIds.every((id) =>
                sf_mucthuphi_selected_ids.includes(id)
              );
            const isPartialSelected = groupItemIds.some((id) =>
              sf_mucthuphi_selected_ids.includes(id)
            );

            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <IconButton
                  icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                  aria-label=""
                  variant="invisible"
                  size="small"
                  onClick={() => toggleGroup(groupKey)}
                />
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={isPartialSelected && !isAllSelected}
                  onChange={(e) =>
                    handleGroupSelection(groupKey, e.target.checked)
                  }
                />
                <Box
                  sx={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    color: "#0969da",
                  }}
                >
                  Nhóm: {groupKey}
                </Box>
              </Box>
            );
          } else {
            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <Checkbox
                  checked={sf_mucthuphi_selected_ids.includes(data.id)}
                  onChange={(e) =>
                    handleItemSelection(data.id, e.target.checked)
                  }
                />
                <Box sx={{ marginLeft: "8px" }}>
                  <TextWithEllipse
                    text={data.ten_khoan_nop || ""}
                    lineNumber={2}
                  />
                </Box>
              </Box>
            );
          }
        },
      },
      {
        caption: "Mã khoản nộp",
        id: "ma_khoan_nop",
        dataField: "ma_khoan_nop",
        width: "150px",
        align: "left",
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          return (
            <TextWithEllipse text={data.ma_khoan_nop || ""} lineNumber={1} />
          );
        },
      },
      {
        caption: "Số tiền định mức",
        id: "so_tien",
        dataField: "so_tien",
        width: "150px",
        align: "right",
        isAllowFocus: false,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          return (
            <div style={{ textAlign: "right" }}>
              {formatVND(data.so_tien || 0)}
            </div>
          );
        },
      },
      {
        caption: "Số tiền phải nộp",
        id: "so_tien_phai_nop",
        dataField: "so_tien_phai_nop",
        width: "150px",
        align: "right",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.so_tien_phai_nop || 0;
          const rowId = data.id;
          return (
            <Box
              sx={{
                width: "100%",
                textAlign: "right",
                "& .dx-texteditor-input": {
                  textAlign: "right",
                },
              }}
            >
              <NumberBox
                value={value}
                format="#,##0"
                width="100%"
                stylingMode="outlined"
                onValueChanged={(e) => {
                  if (
                    e.value !== null &&
                    e.value !== undefined &&
                    e.value !== value
                  ) {
                    handleSoTienChange(rowId, e.value);
                  }
                }}
              />
            </Box>
          );
        },
      },
      {
        caption: "Ghi chú",
        id: "ghi_chu",
        dataField: "ghi_chu",
        minWidth: "150px",
        align: "left",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.ghi_chu || "";
          const rowId = data.id;
          return (
            <Box sx={{ width: "100%" }}>
              <TextInput
                value={value}
                onChange={(e) => {
                  if (e.target.value !== value) {
                    handleGhiChuChange(rowId, e.target.value);
                  }
                }}
                sx={{ width: "100%" }}
              />
            </Box>
          );
        },
      },
    ];

    return result;
  }, [
    expandedGroups,
    sf_mucthuphi_selected_ids,
    raw_data_source,
    toggleGroup,
    handleGroupSelection,
    handleItemSelection,
    handleSoTienChange,
    handleGhiChuChange,
  ]);

  return (
    <DefaultPopup width="80%" title={"Thêm khoản nộp"} onClose={props.onCancel}>
      <div>
        <div>
          <div className="row">
            <div className="col-md-12 padding-top-1rem">
              <DataTable
                titleComponent={
                  <Text
                    text="Danh sách khoản nộp"
                    sx={{ fontSize: 16, fontWeight: 600 }}
                  />
                }
                actionComponent={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <CmbHinhThucNopBom
                      isShowClearButton={true}
                      size="small"
                      width={200}
                      stylingMode="filled"
                      sf_hinhthucnopbom_dotgui={props.sf_hinhthucnopbom_ids}
                      value={
                        hinhThucNopBoms &&
                        hinhThucNopBoms.length > 0 &&
                        hinhThucNopBoms[0]
                          ? hinhThucNopBoms[0].id
                          : undefined
                      }
                      onValueChanged={(id, data) => {
                        if (data) {
                          let arrBom: any[] = [];
                          arrBom.push(data);
                          setHinhThucNopBoms(arrBom);
                        }
                      }}
                      dmCoSoId={dm_coso_id}
                    />
                    <Box sx={{ width: 220 }}>
                      <SelectBoxMultipleKhomKhoanNop
                        width="100%"
                        size="small"
                        isShowClearBtn
                        value={selectedNhomKhoanNopIds}
                        onValueChanged={(ids) => {
                          const safeIds = ids || [];
                          setSelectedNhomKhoanNopIds(safeIds);
                          const names =
                            sf_nhomkhoannops
                              ?.filter((x) => safeIds.includes(x.id))
                              .map((x) => x.nhom_khoan_nop)
                              .filter(Boolean) || [];
                          setSelectedNhomKhoanNopNames(names as string[]);
                        }}
                      />
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <label className="form-label">
                        Tổng tiền phải nộp:{" "}
                        <span style={{ color: "red", fontWeight: 600 }}>
                          {summary?.toLocaleString()}
                        </span>{" "}
                        VNĐ
                      </label>
                    </Box>
                  </Box>
                }
                data={data_source}
                height={`${window.innerHeight - 300}px`}
                columns={columns}
                paging={{
                  enable: false,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <ModalActions>
        <Button
          variant="default"
          leadingVisual={XIcon}
          text="Đóng"
          onClick={() => {
            props.onCancel();
          }}
        />
        <Button
          variant="primary"
          leadingVisual={CheckIcon}
          text="Nộp phí"
          isLoading={props.isSaving}
          disabled={sf_mucthuphi_selected_ids.length === 0}
          onClick={handelSubmit}
        />
      </ModalActions>
    </DefaultPopup>
  );
};
